import PlayQuestion from "../../model/playQuestion";


export function setOptionChosen(
    setState: React.Dispatch<React.SetStateAction<PlayQuestion>>, option: number): void {
    setState((state) => ({ ...state, optionChosen: option }));
}
